/** Fixed timezone for all Dashboard CPT Analytics API requests. */
export const CPT_ANALYTICS_TIMEZONE = "America/New_York";

export const getCptAnalyticsTimezone = () => CPT_ANALYTICS_TIMEZONE;
